import { render, staticRenderFns } from "./corpNetworking.vue?vue&type=template&id=57a17c88&scoped=true"
import script from "./corpNetworking.vue?vue&type=script&lang=js"
export * from "./corpNetworking.vue?vue&type=script&lang=js"
import style0 from "./corpNetworking.vue?vue&type=style&index=0&id=57a17c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a17c88",
  null
  
)

export default component.exports